import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  icon?: BoxIcon;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon: Icon,
  className = '',
  fullWidth = false,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer';
  const variants = {
    primary: 'bg-[#D946EF] text-white hover:bg-[#C026D3] focus:ring-[#D946EF] shadow-sm',
    secondary: 'bg-[#FAE8FF] text-[#A21CAF] hover:bg-[#F5D0FE] focus:ring-[#F5D0FE]',
    outline: 'border-2 border-[#D946EF] text-[#A21CAF] hover:bg-[#FDF4FF] focus:ring-[#D946EF]',
    ghost: 'text-[#A21CAF] hover:bg-[#FAE8FF]/50 hover:text-[#86198F]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) {
      onClick(e);
    }
  };
  return <motion.button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-271">
      {Icon && <Icon className="mr-2" size={size === 'sm' ? 16 : size === 'md' ? 20 : 24} data-id="element-272" />}
      {children}
    </motion.button>;
}